import scaffolding from './vanilla-components/scaffolding'
import 'lazysizes'
import 'svgxuse'

const initDynamicComponents = function() {
    scaffolding()
}

initDynamicComponents()